import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Security = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M30.57 16.254c.501.5.501 1.2 0 1.7L19.94 28.662c-.2.2-.501.4-.902.4-.3 0-.602-.1-.902-.4l-4.713-4.703c-1.103-1.1.601-2.801 1.704-1.7l3.81 3.802 9.827-9.806c.601-.4 1.303-.4 1.805 0Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M37.388 7.149c-5.414 1.1-11.03-1.501-13.837-5.904a1.783 1.783 0 0 0-3.008 0C17.735 5.648 12.02 8.25 6.606 7.15c-1.103-.2-2.106.6-2.106 1.8V27.46c0 5.303 3.41 9.806 8.021 11.407 3.008 1.1 5.816 2.901 8.323 5.103.702.6 1.704.6 2.406 0 2.407-2.202 5.214-4.003 8.222-5.103 4.713-1.701 8.022-6.104 8.022-11.407V8.95c.1-1.2-1.003-2.001-2.106-1.801Zm-.2 20.311c0 4.203-2.708 7.805-6.518 9.206-3.209 1.1-6.116 3.001-8.623 5.203-2.507-2.202-5.415-4.003-8.623-5.203-3.81-1.301-6.518-4.903-6.518-9.206V9.65c5.816.9 11.832-1.8 15.141-6.303 3.209 4.502 9.225 7.204 15.14 6.303v17.81Z"
  })));
});
Security.displayName = 'Security';
Security.defaultProps = {
  'aria-label': 'Security'
};
export default Security;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Security.js
// module id = 3276
// module chunks = 11